import { DocumentsQueryParams } from '@adminServices';
import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { UpdateDocumentDto } from '@klubovna/api-client';
import { Store } from '@ngrx/store';
import * as DocumentsActions from './documents.actions';
import * as DocumentsSelectors from './documents.selectors';

@Injectable({
  providedIn: 'root',
})
export class DocumentsFacade {
  private store = inject(Store);

  documents$ = this.store.select(DocumentsSelectors.selectAllDocuments);
  loading$ = this.store.select(DocumentsSelectors.selectDocumentsLoading);
  error$ = this.store.select(DocumentsSelectors.selectDocumentsError);
  pagination$ = this.store.select(DocumentsSelectors.selectDocumentsPagination);

  documents = toSignal(this.documents$, { initialValue: [] });
  loading = toSignal(this.loading$, { initialValue: false });

  loadDocuments(params?: DocumentsQueryParams): void {
    this.store.dispatch(DocumentsActions.loadDocuments({ params }));
  }

  createDocument(documentData: DocumentsActions.CreateDocumentData): void {
    this.store.dispatch(DocumentsActions.createDocument({ documentData }));
  }

  updateDocument(id: string, documentData: UpdateDocumentDto, fileSk?: File, fileEn?: File): void {
    this.store.dispatch(DocumentsActions.updateDocument({ id, documentData, fileSk, fileEn }));
  }

  deleteDocument(id: string): void {
    this.store.dispatch(DocumentsActions.deleteDocument({ id }));
  }

  uploadDocumentFile(id: string, file: File, lang?: DocumentsActions.DocumentFileLanguage): void {
    this.store.dispatch(DocumentsActions.uploadDocumentFile({ id, file, lang }));
  }

  deleteDocumentFile(id: string, lang?: DocumentsActions.DocumentFileLanguage): void {
    this.store.dispatch(DocumentsActions.deleteDocumentFile({ id, lang }));
  }
}
